import { Link } from "react-router-dom";
import { Container, Logo } from "./shared";

export const LandingNav = () => (
  <header className="sticky top-0 z-40 border-b border-slate-200/70 bg-slate-50/80 backdrop-blur-xl" data-testid="landing-nav">
    <Container className="flex h-16 items-center justify-between">
      <Link to="/" data-testid="landing-logo-link"><Logo /></Link>
      <nav className="flex items-center gap-2">
        <Link to="/login" data-testid="landing-nav-login-button"
          className="flex h-10 items-center rounded-xl px-4 text-sm font-semibold text-slate-700 transition-colors hover:bg-white">Log in</Link>
        <Link to="/register" data-testid="landing-nav-trial-button"
          className="flex h-10 items-center rounded-xl bg-slate-900 px-4 text-sm font-semibold text-white transition-transform active:scale-[0.97]">Start free trial</Link>
      </nav>
    </Container>
  </header>
);

export const LandingFooter = () => (
  <footer className="border-t border-slate-200 py-10" data-testid="landing-footer">
    <Container className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
      <div>
        <Logo />
        <p className="mt-1 text-sm text-slate-500">Photo-based project intake for contractors and home service pros.</p>
      </div>
      <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm font-semibold text-slate-600">
        <Link to="/login" data-testid="footer-login-link">Log in</Link>
        <Link to="/register" data-testid="footer-trial-link">Start free trial</Link>
        <a href="#pricing" data-testid="footer-pricing-link">Pricing</a>
        <a href="#faq" data-testid="footer-faq-link">FAQ</a>
        <Link to="/terms" data-testid="footer-terms-link">Terms</Link>
        <Link to="/privacy" data-testid="footer-privacy-link">Privacy</Link>
      </div>
      <p className="text-xs text-slate-400">© {new Date().getFullYear()} Squadrum</p>
    </Container>
  </footer>
);
